import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const PortfolioWallet = React.lazy(() =>
    import('../PortfolioWallet')
);
const portfolioWalletRoutesRegistry = [
    {
        path: PAGE_URL.PORTFOLIO_WALLET_PAGE,
        element: <PortfolioWallet />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default portfolioWalletRoutesRegistry;
